<div class="app-container">
  <div class="app-main-header" *ngIf="config.layout.navbar.visibility">
      <app-default-navbar></app-default-navbar>
  </div>
  <div class="app-main-body">
      <div class="app-main-content">
          <div class="app-sidebar d-none d-lg-block">
              <app-default-sidebar></app-default-sidebar>
          </div>
          <div class="app-content">
              <router-outlet></router-outlet>
          </div>
      </div>
      <div class="app-footer" *ngIf="config.layout.footer.visibility">
      </div>
  </div>
</div>
